import { render } from "./ByosChoosenProducts.vue?vue&type=template&id=4153bc1c"
import script from "./ByosChoosenProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./ByosChoosenProducts.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/byos/ByosChoosenProducts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4153bc1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4153bc1c', __exports__)) {
    api.reload('4153bc1c', __exports__)
  }
  
  module.hot.accept("./ByosChoosenProducts.vue?vue&type=template&id=4153bc1c", () => {
    api.rerender('4153bc1c', render)
  })

}


export default __exports__